export default {
  'subscriptionList.title': '订阅记录',
  'subscriptionList.form.shopifyId': 'Shopify 店铺 ID',
  'subscriptionList.form.shopifyId.placeholder': 'Shopify 店铺 ID',
  'subscriptionList.form.merchant': '商户',
  'subscriptionList.form.merchant.placeholder': '请选择商户',
  'subscriptionList.form.status': '订阅状态',
  'subscriptionList.form.status.placeholder': '请选择订阅状态',
  'subscriptionList.form.customerEmail': '客户邮箱',
  'subscriptionList.form.customerEmail.placeholder': '客户邮箱（模糊）',
  'subscriptionList.form.originalOrderId': '原始订单 ID（首单）',
  'subscriptionList.form.originalOrderId.placeholder': '原始订单 ID（首单）',
  'subscriptionList.form.subscriptionOrderId': '当次订单 ID',
  'subscriptionList.form.subscriptionOrderId.placeholder': '当次订单 ID',
  'subscriptionList.form.dateRange': '日期范围',
  'subscriptionList.form.startDate': '开始日期',
  'subscriptionList.form.endDate': '结束日期',
  'subscriptionList.form.search': '查询',
  'subscriptionList.form.reset': '重置',
  'subscriptionList.columns.index': '#',
  'subscriptionList.columns.shopifyId': 'Shopify 店铺 ID',
  'subscriptionList.columns.merchant': '商户',
  'subscriptionList.columns.customerEmail': '客户邮箱',
  'subscriptionList.columns.status': '状态',
  'subscriptionList.columns.originalOrderId': '原始订单 ID',
  'subscriptionList.columns.subscriptionOrderId': '当次订单 ID',
  'subscriptionList.columns.createdAt': '创建时间',
  'subscriptionList.columns.updatedAt': '更新时间',
  'subscriptionList.columns.operations': '操作',
  'subscriptionList.columns.operations.pause': '暂停',
  'subscriptionList.columns.operations.pauseConfirm': '确认暂停该订阅？',
  'subscriptionList.columns.operations.pauseSuccess': '暂停成功',
  'subscriptionList.columns.operations.pauseError': '暂停失败',
  'subscriptionList.columns.operations.resume': '恢复',
  'subscriptionList.columns.operations.resumeConfirm': '确认恢复该订阅为活跃状态？',
  'subscriptionList.columns.operations.resumeSuccess': '恢复成功',
  'subscriptionList.columns.operations.resumeError': '恢复失败',
  'subscriptionList.columns.operations.cancel': '取消',
  'subscriptionList.columns.operations.cancelConfirm': '确认取消该订阅？',
  'subscriptionList.columns.operations.cancelSuccess': '取消成功',
  'subscriptionList.columns.operations.cancelError': '取消失败',
  'subscriptionList.columns.operations.unsubscribe': '退订',
  'subscriptionList.columns.operations.unsubscribeConfirm':
    '确认退订该订阅？',
  'subscriptionList.columns.operations.unsubscribeSuccess': '退订成功',
  'subscriptionList.columns.operations.unsubscribeError': '退订失败',
  'subscriptionList.operation.batchActions': '批量操作',
  'subscriptionList.operation.batchCancel': '取消',
  'subscriptionList.operation.batchPause': '暂停',
  'subscriptionList.operation.batchActive': '活跃',
  'subscriptionList.operation.batchCancelConfirm':
    '确认批量取消选中的活跃订阅？',
  'subscriptionList.operation.batchPauseConfirm':
    '确认批量暂停选中的活跃订阅？',
  'subscriptionList.operation.batchActiveConfirm':
    '确认将选中的暂停订阅设为活跃？',
  'subscriptionList.operation.batchCancelSuccess': '批量取消成功',
  'subscriptionList.operation.batchCancelError': '批量取消失败',
  'subscriptionList.operation.batchPauseSuccess': '批量暂停成功',
  'subscriptionList.operation.batchPauseError': '批量暂停失败',
  'subscriptionList.operation.batchActiveSuccess': '批量活跃成功',
  'subscriptionList.operation.batchActiveError': '批量活跃失败',
  'subscriptionList.operation.noSelection': '请先选择订阅记录',
  'subscriptionList.operation.noEligible': '所选记录中没有可操作的活跃订阅',
  'subscriptionList.operation.noEligiblePaused':
    '所选记录中没有可设为活跃的暂停订阅',
  'subscriptionList.operation.export': '导出',
  'subscriptionList.export.viewProgress': '查看导出进度',
  'subscriptionList.status.active': '活跃',
  'subscriptionList.status.paused': '暂停',
  'subscriptionList.status.cancelled': '已取消',
  'subscriptionList.status.failed': '失败',
  'subscriptionList.status.expired': '已过期',
  'subscriptionList.status.renewed': '已续费',
};
